import React from 'react';
import PropTypes from 'prop-types'
import '../Qrcode.css';

const FrameworkParam = ({ paramName, children, ...other }) => (
    <table className="col-lg-6 col-md-6 col-sm-12 col-xs-12" {...other}>
        <tbody>
        <tr>
            <td>{ paramName }</td>
            <td width="60%">
                { children }
            </td>
        </tr>
        </tbody>
    </table>
)

export default FrameworkParam;
